import moment from "moment";
import { defaultNullHtml } from "@/js/defaultNullHtml";

export function getDateFormatted(date) {
  return (
    date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
  );
}

export function getDateFormattedLocal(date) {
  return moment(date).format("DD.MM.YYYY");
}

export function getDateTimeHtml(content) {
  const date = moment(content);

  return date.isValid()
    ? date.format("DD.MM.YYYY HH:mm:ss")
    : defaultNullHtml();
}

export function getDateTimeHtmlAddMinutes(content, minutes) {
  const date = moment(content);
  date.add(minutes, "minutes");

  return date.isValid()
    ? date.format("DD.MM.YYYY HH:mm:ss")
    : defaultNullHtml();
}

export function getTimeDifference(date1) {
  return moment(moment().diff(moment(date1)))
    .subtract(1, "hour")
    .format("HH:mm:ss");
}
